angular.module('admin.administrators', [
  'admin.administrators.index',
  'admin.administrators.detail'
]);


// WEBPACK FOOTER //
// ./client/src/app/admin/administrators/index.js